import React, { cloneElement, CSSProperties } from 'react';
import styles from '../CountHiddenTags.module.scss';
import { ICountHiddenTagsProps } from '../models';
import { TooltipNew } from '@src/atoms/TooltipNew';

interface IProps extends Pick<ICountHiddenTagsProps, 'withMoreTooltip' | 'tooltipContent'> {
  moreStyles: CSSProperties;
  moreComponent: JSX.Element;
}

export const MoreExternal = ({ moreStyles, withMoreTooltip, moreComponent, tooltipContent }: IProps) => {
  if (!moreComponent) return null;

  if (withMoreTooltip && tooltipContent) {
    return (
      <TooltipNew content={tooltipContent}>
        {cloneElement(moreComponent, { style: moreStyles, className: styles.more })}
      </TooltipNew>
    );
  }

  return cloneElement(moreComponent, { style: moreStyles, className: styles.more });
};
